export default __webpack_public_path__ + "static/media/img-gtl-swp@3x.b85e6ece.png";